import type { Draft, Slice, SliceSelectors } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { placeOrder } from "@store/slices/LEGACY__checkoutSlice/actions/placeOrder";

import { fetchContactEmail } from "./actions/fetchContactEmail";
import { fetchOrder } from "./actions/fetchOrder";
import { fetchOrderPoints } from "./actions/fetchOrderPoints";
import { fetchPaymentMethod } from "./actions/fetchPaymentMethod";

import type { OrderState } from "./LEGACY__orderSlice.types";

export const initialOrderState: OrderState = {
  orderDetails: {
    fetchStatus: "idle",
    data: null,
  },
  orderNumber: undefined,
  contactEmail: undefined,
  paymentMethod: undefined,
  points: 0,
};

/**
 * @deprecated
 */
export const LEGACY__orderSlice: Slice<
  OrderState,
  {
    resetOrderNumber: (state: Draft<OrderState>) => void;
  },
  "LEGACY__order",
  "LEGACY__order",
  SliceSelectors<OrderState>
> = createSlice({
  name: "LEGACY__order",
  initialState: initialOrderState,
  reducers: {
    resetOrderNumber: (state) => {
      state.orderNumber = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchOrder.rejected, (state) => {
      state.orderDetails.fetchStatus = "error";
    });
    builder.addCase(fetchOrder.pending, (state) => {
      state.orderDetails.fetchStatus = "pending";
    });
    builder.addCase(fetchOrder.fulfilled, (state, action) => {
      state.orderDetails.fetchStatus = "success";
      state.orderDetails.data = action.payload;
    });
    builder.addCase(fetchPaymentMethod.fulfilled, (state, action) => {
      state.paymentMethod = action.payload;
    });
    builder.addCase(placeOrder.fulfilled, (state, action) => {
      state.orderNumber = action.payload.orderNumber;
    });
    builder.addCase(fetchContactEmail.fulfilled, (state, action) => {
      state.contactEmail = action.payload.personalInfo.email;
    });
    builder.addCase(fetchOrderPoints.fulfilled, (state, action) => {
      state.points = action.payload;
    });
  },
});

export const { resetOrderNumber } = LEGACY__orderSlice.actions;
